import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Main from '../../../component/Main';
import Loading from '../../../component/common/loading/Loading';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect';
import FidelityExcelDownload from './FidelityExcelDownload';
import generateFidelityList from './generate_fidelity_mng_list';
import useModalStore from '../../../zustand/store/useModalStore';

import '../../../css/data-grid.css';
import { useDynamicStyle } from '../../../hooks/useDynamicStyle';
import { Search16w } from '../../../images/icons/icons_component';

// 엑셀 다운로드 컬럼 너비 설정값
const COMP_INFO_MNG_COL_WIDTHS = [7, 17, 17, 60, 12, 12, 12, 15, 15, 15, 15, 15, 15, 12, 12, 12];

// 비고 - 엑셀 다운로드에 그대로 포함되도록 table 로 구성
const COMP_INFO_MNG_DESC_TEXTS = [
    '· 정상저장률 : 항목 간 전후관계가 일관되게 입력됨을 의미',
    '· 재검토율 : 오류내역은 아니지만 확인이 필요한 경우를 의미',
    '· 오류율 : 항목 간 전후관계가 부합되거나 자료 입력에 규칙성(고정 값)이 존재하는 경우를 의미',
    '· 퇴원정보의 미입력률에는 재원중인 환자도 포함될 수 있음.'
];

const CompInfoMngStatMonthly = () => {

    const today = new Date();
    const currentYear = today.getFullYear();
    let currentMonth = today.getMonth() + 1;
    if (currentMonth < 10) {
        currentMonth = '0' + currentMonth;
    }

    const [searchParams, setSearchParams] = useState({
        searchYear: currentYear,
        searchMonth: currentMonth,
        searchEmog: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('useremcd') : '',
        searchGrdc: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('emoggrdc2') : '',
        searchLoca: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('emogloca') : '',
        searchType: '01',
        fromindt: currentYear + currentMonth + '01',
        toindt: currentYear + currentMonth + '31',
        beforefromindt: currentMonth - 1 === 0 ? currentYear - 1 + '1201' : currentYear + currentMonth - 1 + '01',
        beforetoindt: currentMonth - 1 === 0 ? currentYear - 1 + '1231' : currentYear + currentMonth - 1 + '31'
    });

    const [searchBeforeParams, setSearchBeforeParams] = useState({
        searchYear: currentYear,
        searchMonth: currentMonth,
        searchEmog: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('useremcd') : '',
        searchGrdc: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('emoggrdc2') : '',
        searchLoca: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('emogloca') : '',
        searchType: '01',
        fromindt: currentMonth - 1 === 0 ? currentYear - 1 + '1201' : currentYear + currentMonth - 1 + '01',
        toindt: currentMonth - 1 === 0 ? currentYear - 1 + '1231' : currentYear + currentMonth - 1 + '31'
    });

    const [isSearched, setIsSearched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [fidelityData, setFidelityData] = useState([{}]);
    const [fidelityBeforeData, setFidelityBeforeData] = useState([{}]);
    const [totalItems, setTotalItems] = useState([0, 0]);

    // 엑셀 파일명을 '조회 시점' 기준으로 고정하기 위한 state
    const [excelInfo, setExcelInfo] = useState({ emogdesc: '', period: '' });
    // 엑셀 다운로드 대상 ref
    const tableRef = useRef(null);

    // toast modal open function
    const showNotiModal = useModalStore(state => state.showNotiModal);

    const search = () => {
        if (searchParams.searchEmog === '') {
            showNotiModal('먼저 해당 응급의료기관을 선택하십시오.');
        } else {
            setIsLoading(true);
            getfidelityData();
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        if (name === 'searchType') {
            setIsSearched(false);
        }
        if (name === 'searchYear' || name === 'searchMonth' || name === 'searchEmog') {
            const year = name === 'searchYear' ? value : searchParams.searchYear;
            const month = name === 'searchMonth' ? value : searchParams.searchMonth;

            const paddedMonth = String(month).padStart(2, '0');
            const prevMonth = parseInt(month) - 1 || 12;
            const prevYear = prevMonth === 12 ? parseInt(year) - 1 : parseInt(year);
            const paddedPrevMonth = String(prevMonth).padStart(2, '0');

            const fromindt = `${year}${paddedMonth}01`;
            const toindt = `${year}${paddedMonth}31`;
            const beforefromindt = `${prevYear}${paddedPrevMonth}01`;
            const beforetoindt = `${prevYear}${paddedPrevMonth}31`;

            newParams.fromindt = fromindt;
            newParams.toindt = toindt;

            const updatedBeforeParams = {
                ...newParams,
                fromindt: beforefromindt,
                toindt: beforetoindt
            };

            setSearchParams(newParams);
            setSearchBeforeParams(updatedBeforeParams);
        } else {
            setSearchParams(newParams);
        }
    };

    const [bodylist, setBodyList] = useState([]);
    const head = ['진단항목', '정상저장률(%)', '증감', '재검토율(%)', '증감', '오류율(%)', '증감'];
    const except_body = ['PTMIINMN', 'PTMIEMRT'];
    const except_column = ['PTMIDGKD_2', 'PTMIEMSY']

    const bodyData = async () => {
        try {
            const response = await axios.get('/ptmiapi/fidelity_list.do',
                { params: { listType: 'MANAGE' } }
            );

            setBodyList(response.data.fidelitylist);

        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    const getfidelityData = async () => {
        try {
            const response = await axios.get('/ptmiapi/fidelity_mng_data.do',
                { params: searchParams }
            );

            setFidelityData(generateFidelityList(bodylist, response.data, searchParams.searchType));

            const response2 = await axios.get('/ptmiapi/fidelity_mng_data.do',
                { params: searchBeforeParams }
            );
            setFidelityBeforeData(generateFidelityList(bodylist, response2.data, searchBeforeParams.searchType));

            const cnt = response.data?.statInfo.TOTAL_CNT1 ?? 0;
            const beforeCnt = response2.data?.statInfo.TOTAL_CNT1 ?? 0;
            setTotalItems([beforeCnt, cnt]);
            setExcelInfo({
                emogdesc: response.data?.statInfo.EMOGDESC,
                period: searchParams.fromindt.substring(0, 6)
            });

            setIsSearched(true);
            setIsLoading(false);

        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    useEffect(() => {
        bodyData();
    }, []);

    const highlightText = (text) => {
        if (typeof text !== 'string') return text;

        // *로 시작하는 경우 스타일 적용
        if (text.trim().startsWith('*')) {
            return <span className='co_red'>{text}</span>;
        }

        return text;
    };

    const extraColumnTexts = [
        '연령과 성별의 일치 여부',
        '* 내원 2일(48시간)이내 발병시간이 내원시간과 동일하게 전송된 경우',
        <>질병여부가 default '-' 인데 응급진료결과가 귀가(10), 전원(20),<br />
            입원(30), 사망(40)인 경우 오류
        </>,
        '* 질병여부에서 질병(1)과 질병 외(2) 입력률',
        <>
            응급진료결과가 전원(20), 입원(30), 사망(40)인데 질병여부가 진료외 방문(3)<br />
            으로 전송된 경우 오류(단, 주증상에 C0184701, C0582452, C0809949,<br />
            C0006110, C0004398 로 입력되어 있는 환자는 제외)
        </>,
        <>교통사고 손상 당사자는 입력되어 있으나 손상기전에는 교통사고(01, 03, 04, 08, 09)<br />가 전송되지 않은 경우
        </>,
        '전혀 착용 안 함, 비해당, 미상 중 하나로 체크되어 있는데 보호장구가 선택되어 있는지 여부',
        <>전원 보낸 의료기관 종류와 코드가 불일치하는 경우(예. 종류는 종합병원으로<br />
            표기되어 있는데 코드는 의원이 입력된 경우)
        </>,
        '* 응급증상 해당여부에서 응급(Y)과 비응급(N) 입력률',
        '내원 시 반응이 P 또는 U인데, 내원수단이 ‘도보(7)’인 경우',
        <>
            1. 응급진료결과 41번인데 내원시 반응이 A,V,P로 전송된경우<br />
            2. 응급진료결과 42,43번인데 내원시 반응이 A로 전송된경우
        </>,
        <>전원 보낼 의료기관 종류와 코드가 불일치하는 경우(예. 종류는 종합병원으로<br />
            표기되어 있는데 코드는 의원이 입력된 경우)
        </>,
        <>
            1. 응급진료결과는 전송되었는데, 퇴실일시가 미전송된 경우 오류<br />
            2. 퇴실일시-내원일시가 7일 이상일 경우 재검토
        </>,
        '입원후 결과는 전송되었는데, 퇴원일시가 미전송된 경우',
        '퇴원일시가 미전송 되었는데 입원 정보는 전송된 경우'
    ];

    const renderExtraColumn = (index) => {
        const content = extraColumnTexts[index];

        // JSX가 아닌 문자열만 강조 대상
        return highlightText(content);
    };

    const getCurrentData = (code, dataname) =>
        fidelityData?.find((d) => d.FIDELITY_ID === code)?.[dataname];

    const getBeforeData = (code, dataname) =>
        fidelityBeforeData?.find((d) => d.FIDELITY_ID === code)?.[dataname];

    const getDataValue = (code, dataname) => {
        if (!isSearched) return '';
        if (except_column.includes(code) && dataname !== 'ORG_REVIEW') return ' ';
        if (except_column.includes(code) && dataname === 'ORG_REVIEW') return '';
        return getCurrentData(code, dataname) ?? ' ';
    };

    const getDisplayValue = (code, dataname, type) => {
        if (!isSearched) return '0.00';
        if (except_column.includes(code) && !dataname.includes('ORG_REVIEW_')) return ' ';
        const current = getCurrentData(code, dataname).trim();
        const before = getBeforeData(code, dataname).trim();
        const diff = (current != '' && before != '') ? current - before : NaN;
        let returndata = '';
        if (type === 'current') {
            returndata = isNaN(current) ? '-' : current;
        } else if (type === 'before') {
            returndata = isNaN(before) ? '-' : before;
        } else if (type === 'diff') {
            returndata = isNaN(diff) ? '' : diff.toFixed(2);
        }
        return returndata
    };

    // Dynamic Style Hook
    const { fontColor, primaryBackColor, borderColorGray } = useDynamicStyle();

    return (
        <Main>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width='10%' />
                        <col width='20%' />
                        <col width='10%' />
                        <col width='20%' />
                        <col width='10%' />
                        <col width='20%' />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                exValidation={true}
                            />
                        </tr>
                        <tr>
                            <th>내원기간</th>
                            <td>
                                <select id='searchYear'
                                    name='searchYear'
                                    value={searchParams.searchYear}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 10 }, (_, i) => {
                                        const year = (currentYear - i).toString()
                                        return (
                                            <option key={year} value={year}>
                                                {year} 년
                                            </option>
                                        );
                                    })}
                                </select>
                                &ensp;
                                <select id='searchMonth'
                                    name='searchMonth'
                                    value={searchParams.searchMonth}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 12 }, (_, i) => {
                                        const month = (i + 1).toString().padStart(2, '0');
                                        return (
                                            <option key={month} value={month}>
                                                {month} 월
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                            <th>기관구분</th>
                            <td colSpan='3'>
                                <select id='searchType'
                                    name='searchType'
                                    value={searchParams.searchType}
                                    onChange={handleInputChange}
                                >
                                    <option value='01'>센터형</option>
                                    <option value='02'>기관형</option>
                                </select>
                                <span className='co_red ml-2'>* 표출되는 항목에 영향을 줍니다.</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='search_btn_wrapper'>
                <span className='total_items'>전월 : 총&nbsp;<strong className={fontColor}>{totalItems[0]}</strong>건 / 금월 : 총&nbsp;<strong className={fontColor}>{totalItems[1]}</strong>건</span>
                <div className='btn_container'>
                    <button onClick={search} disabled={isLoading ? 'disabled' : ''} className={`search_btn ${primaryBackColor}`}><Search16w />검색</button>
                    <FidelityExcelDownload
                        targetRef={tableRef}
                        disabled={!(isSearched && !isLoading)}
                        excelFileName={`충실도_월별정보관리내역비교_${excelInfo.emogdesc}_${excelInfo.period}(${searchParams.searchType === '01' ? '센터형' : '기관형'})`}
                        colWidths={COMP_INFO_MNG_COL_WIDTHS}
                    />
                </div>
            </div>
            {isLoading && <Loading />}
            <div ref={tableRef} className={`flex flex-col flex-grow min-h-0 ${isLoading ? 'hidden' : ''}`}>
                <div className='data_grid_container'>
                    <hr className={`border-t-2 mr-1-1 ${borderColorGray}`}/>
                    <div className={`data_list_table ${isSearched ? 'grid-animation' : ''}`}>
                        <table>
                            <colgroup>
                                <col width='3%' />
                                <col width='5%' />
                                <col width='7%' />
                                <col width='25%' />
                                <col width='6%' />
                                <col width='6%' />
                                <col width='6%' />
                                <col width='4%' />
                                <col width='4%' />
                                <col width='4%' />
                                <col width='4%' />
                                <col width='4%' />
                                <col width='4%' />
                                <col width='6%' />
                                <col width='6%' />
                                <col width='6%' />
                            </colgroup>

                            <thead>
                                <tr className='table_header'>
                                    {head.map((content, index) => (
                                        <th rowSpan={index === 0 ? 2 : 1}
                                            colSpan={index === 0 ? 4 : index === 3 ? 4 : index === 4 ? 2 : index % 2 !== 0 ? 2 : 1}
                                            key={index}>
                                            {content}
                                        </th>
                                    ))}
                                </tr>
                                <tr className='table_header'>
                                    {Array.from({ length: 9 }, (_, i) => {
                                        // 재검토율 그룹(3~5)은 질병/질병외 분할 셀 위에 있으므로 2칸씩 차지
                                        const span = i >= 3 && i <= 5 ? 2 : 1;
                                        if (i % 3 == 0) return (<th colSpan={span} key={i}>{searchParams.searchMonth - 1 === 0 ? 12 : String(searchParams.searchMonth - 1).padStart('2', 0)}월</th>)
                                        if (i % 3 == 1) return (<th colSpan={span} key={i}>{searchParams.searchMonth}월</th>)
                                        if (i % 3 == 2) return (<th colSpan={span} key={i}>(%p)</th>)
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {bodylist.filter(content => !(searchParams.searchType === '02' && content.FIDELITY_TYPE === '02')).map((content, index) => {
                                    const isSubRow = except_column.includes(content.FIDELITY_CODE);
                                    const rowSpanSet = isSubRow ? 2 : 1;
                                    const rowClass = searchParams.searchType === '02' && content.FIDELITY_TYPE === '02' ? 'hidden' : content.FIDELITY_TYPE === '02' ? '' : ' colored';
                                    const subLabels = content.FIDELITY_CODE === 'PTMIDGKD_2' ? ['질병', '질병외'] : ['응급증상율', '비응급증상율'];
                                    return (
                                        <React.Fragment key={index + 1}>
                                            <tr className={rowClass} data-cls={content.SEQ < 10 ? '0' + (content.SEQ) : content.SEQ}>
                                                <td rowSpan={rowSpanSet}>{index + 1}</td>
                                                {content.FIDELITY_CODE === 'PTMIINMN' ? <td className='middle' rowSpan='2'><span>내원 시<br /> 활력징후</span></td> : ''}
                                                {content.FIDELITY_CODE.includes('PTMIDGKD_') ? '' : <td rowSpan={content.FIDELITY_CODE === 'PTMIDGKD' ? '4' : content.FIDELITY_CODE === 'PTMIEMSY' ? '2' : '1'} colSpan={except_body.includes(content.FIDELITY_CODE) ? '1' : '2'}>{content.FIDELITY_NAME}</td>}
                                                <td rowSpan={rowSpanSet} className='text-left'>{renderExtraColumn(index)}</td>
                                                <td rowSpan={rowSpanSet} id={content.FIDELITY_CODE} data-value={getDataValue(content.FIDELITY_CODE, 'ORG_NORMAL')}>{getDisplayValue(content.FIDELITY_CODE, 'ORG_NORMAL', 'before')}</td>
                                                <td rowSpan={rowSpanSet} id={content.FIDELITY_CODE} data-value={getDataValue(content.FIDELITY_CODE, 'ORG_NORMAL')}>{getDisplayValue(content.FIDELITY_CODE, 'ORG_NORMAL', 'current')}</td>
                                                <td rowSpan={rowSpanSet} id={content.FIDELITY_CODE} data-value={getDataValue(content.FIDELITY_CODE, 'ORG_NORMAL')}>{getDisplayValue(content.FIDELITY_CODE, 'ORG_NORMAL', 'diff')}</td>
                                                {isSubRow ? (
                                                    <>
                                                        {[0, 1, 2].map((groupIdx) => (
                                                            <React.Fragment key={groupIdx}>
                                                                <td className='h-8 py-1 bold'>{subLabels[0]}</td>
                                                                <td className='h-8 py-1 bold'>{subLabels[1]}</td>
                                                            </React.Fragment>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <>
                                                        <td colSpan={2} id={content.FIDELITY_CODE} data-value={getDataValue(content.FIDELITY_CODE, 'ORG_REVIEW')}>{getDisplayValue(content.FIDELITY_CODE, 'ORG_REVIEW', 'before')}</td>
                                                        <td colSpan={2} id={content.FIDELITY_CODE} data-value={getDataValue(content.FIDELITY_CODE, 'ORG_REVIEW')}>{getDisplayValue(content.FIDELITY_CODE, 'ORG_REVIEW', 'current')}</td>
                                                        <td colSpan={2} id={content.FIDELITY_CODE} data-value={getDataValue(content.FIDELITY_CODE, 'ORG_REVIEW')}>{getDisplayValue(content.FIDELITY_CODE, 'ORG_REVIEW', 'diff')}</td>
                                                    </>
                                                )}
                                                <td rowSpan={rowSpanSet} id={content.FIDELITY_CODE} data-value={getDataValue(content.FIDELITY_CODE, 'ORG_ERROR')}>{getDisplayValue(content.FIDELITY_CODE, 'ORG_ERROR', 'before')}</td>
                                                <td rowSpan={rowSpanSet} id={content.FIDELITY_CODE} data-value={getDataValue(content.FIDELITY_CODE, 'ORG_ERROR')}>{getDisplayValue(content.FIDELITY_CODE, 'ORG_ERROR', 'current')}</td>
                                                <td rowSpan={rowSpanSet} id={content.FIDELITY_CODE} data-value={getDataValue(content.FIDELITY_CODE, 'ORG_ERROR')}>{getDisplayValue(content.FIDELITY_CODE, 'ORG_ERROR', 'diff')}</td>
                                            </tr>
                                            {isSubRow && (
                                                <tr className={rowClass} data-cls={content.SEQ < 10 ? '0' + (content.SEQ) : content.SEQ}>
                                                    <td className='h-8 py-1 sub_table'>{getDisplayValue(content.FIDELITY_CODE, 'ORG_REVIEW_1', 'before')}</td>
                                                    <td className='h-8 py-1 sub_table'>{getDisplayValue(content.FIDELITY_CODE, 'ORG_REVIEW_2', 'before')}</td>
                                                    <td className='h-8 py-1 sub_table'>{getDisplayValue(content.FIDELITY_CODE, 'ORG_REVIEW_1', 'current')}</td>
                                                    <td className='h-8 py-1 sub_table'>{getDisplayValue(content.FIDELITY_CODE, 'ORG_REVIEW_2', 'current')}</td>
                                                    <td className='h-8 py-1 sub_table'>{getDisplayValue(content.FIDELITY_CODE, 'ORG_REVIEW_1', 'diff')}</td>
                                                    <td className='h-8 py-1 sub_table'>{getDisplayValue(content.FIDELITY_CODE, 'ORG_REVIEW_2', 'diff')}</td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <hr className='mr-1-1 co_border_gray'/>
                    {/* 범례 - 엑셀전용 table (그리드 최대 컬럼수에 맞춤) */}
                    <table>
                        <colgroup>
                            {Array.from({ length: COMP_INFO_MNG_COL_WIDTHS.length }).map((_, idx) => (
                                <col key={idx} width={`${100 / COMP_INFO_MNG_COL_WIDTHS.length}%`} />
                            ))}
                        </colgroup>
                        <tbody>
                            <tr>
                                <td colSpan={6} className='border-none py-0'>
                                    <div className='flex mt-2 items-center'>
                                        <span className='st_row bold'>■ </span>
                                        <p className='ml-1'>&nbsp;센터급, 기관급 공통항목&nbsp;</p>
                                        <span className='co_red'>&nbsp;* 재검토 항목</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={COMP_INFO_MNG_COL_WIDTHS.length} className='border-none pt-0'></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {/* 비고 - 엑셀전용 table (그리드 최대 컬럼수에 맞춤) */}
                <table>
                    <colgroup>
                        {Array.from({ length: COMP_INFO_MNG_COL_WIDTHS.length }).map((_, idx) => (
                            <col key={idx} width={`${100 / COMP_INFO_MNG_COL_WIDTHS.length}%`} />
                        ))}
                    </colgroup>
                    <tbody>
                        {COMP_INFO_MNG_DESC_TEXTS.map((content, index) => (
                            <tr key={index}>
                                {/* (excel_black_text : 엑셀전용 클래스) */}
                                <td colSpan={COMP_INFO_MNG_COL_WIDTHS.length} className='border-none pt-0 excel_black_text'>
                                    <p className='ml-2'>{content}</p>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Main>
    )
}

export default CompInfoMngStatMonthly;
